import { useParams, Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function DetailHero() {
  const { id } = useParams<{ id: string }>();
  const article = newsArticles.find((a) => a.id === id);

  if (!article) return null;

  return (
    <section className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={article.coverImage}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full px-6 flex flex-col items-center text-center max-w-3xl mx-auto">
        <div className="flex items-center gap-2 text-foreground-400 text-xs mb-4 flex-wrap justify-center">
          <Link to="/" className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link
            to={`/category/${article.categorySlug}`}
            className="hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            {article.category}
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-500">正文</span>
        </div>

        <h1 className="font-heading text-xl md:text-4xl font-black text-foreground-950 leading-tight tracking-wide">
          {article.title}
        </h1>

        <div className="mt-4 md:mt-5 flex flex-wrap items-center justify-center gap-4 text-foreground-400 text-xs">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i> {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i> {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views}阅读`}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-price-tag-3-line"></i>
            {article.tags.join(' · ')}
          </span>
        </div>

        <div className="mt-6 flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300/30 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap">
            <i className="ri-share-forward-line text-sm"></i>
          </button>
          <button className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300/30 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap">
            <i className="ri-bookmark-line text-sm"></i>
          </button>
          <button className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300/30 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-all duration-200 cursor-pointer whitespace-nowrap">
            <i className="ri-heart-line text-sm"></i>
          </button>
        </div>
      </div>
    </section>
  );
}